import React, { useState, useEffect } from "react";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Avatar from "@mui/material/Avatar";
import { borderRadius, Box } from "@mui/system";
import { Grid } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { userLogs } from "../../Js/Common";
import { defsSliceActions } from "../../Store/Slices/DefsSlice";
import { installationSliceActions } from "../../Store/Slices/InstallationSlice";

const Profile = (props) => {
  // Hooks
  const dispatch = useDispatch();
  const navigation = useNavigate();

  // State
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const { serverRole } = useSelector((state) => state.defs);
  const { whoAmIData } = useSelector((state) => state.installation);

  // Logout logic
  const logout = async () => {
    localStorage.removeItem("feathers-jwt");
    let logObj = {
      actor: userInfo.uid,
      site_uuid: userInfo.site_uuid,
      verb: "logout",
      target: null,
      context: null,
      outcome: null,
    };
    await userLogs(logObj);
    let serverData = serverRole;
    let whoAmIFileData = whoAmIData;
    if (document.fullscreenElement) {
      document
        .exitFullscreen()
        .then(() => console.log("Document Exited from Full screen mode"))
        .catch((err) => console.error(err));
    }
    setTimeout(() => {
      dispatch({ type: "RESET_APP" });
      dispatch(defsSliceActions.setServerRole(serverData));
      dispatch(installationSliceActions.setWhoAmIData(whoAmIFileData));
    }, 500);
    navigation("/");
  };

  // Go To Manage Profile
  // const goTo = () => {
  //   setModalVisible(false);
  //   navigation.navigate("ManageProfile");
  // };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const openTutorials = () => {
    let url = "";
    if (userInfo.rolesInfo.title.toLowerCase() == "trainer") {
      url = "https://update.wordsworthlab.com/product_tutorials/desktop/trainer/";
    } else {
      url = "https://update.wordsworthlab.com/product_tutorials/desktop/learner/";
    }
    
    window.open(url,"_blank")
  };

  return (
    <div>
      <Button aria-describedby={id} onClick={handleClick}>
        <Avatar
          sx={{
            bgcolor: "primary.main",
            "@media (min-width: 1636px)": {
              fontSize: "1.4rem",
              height: "3rem",
              width: "3rem",
            },
          }}
        >
          {userInfo !== undefined &&
            userInfo !== null &&
            (userInfo.name.firstname
              ? userInfo.name.firstname.toUpperCase()[0]
              : "") +
              "" +
              (userInfo.name.lastname
                ? userInfo.name.lastname.toUpperCase()[0]
                : "")}
        </Avatar>
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        sx={{ textAlign: "center" }}
        PaperProps={{ style: { borderRadius: "35px" } }}
      >
        <Box sx={{}}>
          <Grid sx={{ py: 2, px: 3 }}>
            <Grid sx={{ px: 1, py: 2 }}>
              <Typography
                fontSize={"1.3rem"}
                sx={{
                  color: "primary.main",
                  "@media (min-width: 1636px)": {
                    fontSize: "1.6rem",
                  },
                }}
              >
                <span className="textbold">
                  {userInfo !== undefined &&
                    userInfo !== null &&
                    userInfo.name.firstname + " " + userInfo.name.lastname}
                </span>
              </Typography>
              <Typography
                fontSize={"0.8rem"}
                sx={{
                  color: "primary.subhead",
                  "@media (min-width: 1636px)": {
                    fontSize: "1.4rem",
                  },
                }}
              >
                <span>
                  {userInfo !== undefined &&
                    userInfo !== null &&
                    userInfo.rolesInfo &&
                    userInfo.rolesInfo.title}
                </span>
              </Typography>
            </Grid>
            {userInfo !== undefined &&
              userInfo !== null &&
              userInfo.rolesInfo &&
              (userInfo.rolesInfo.title.toLowerCase() == "trainer" ||
                userInfo.rolesInfo.title.toLowerCase() == "learner") && (
                <Grid>
                  <Button
                    variant="outline"
                    color="success"
                    fullWidth
                    sx={{
                      borderRadius: 10,
                      border: 1,
                      color: "primary.main",
                      fontWeight: "bold",
                      "@media (min-width: 1636px)": {
                        fontSize: "1rem",
                      },
                    }}
                    onClick={() => {
                      openTutorials();
                    }}
                  >
                    Guide
                  </Button>
                </Grid>
              )}
            {/* <Grid>
              <Button
                variant="outline"
                color="success"
                sx={{
                  borderRadius: 10,
                  border: 1,
                  mt: "4px",
                  color: "primary.main",
                  fontWeight: "bold",
                  "@media (min-width: 1636px)": {
                    fontSize: "1rem",
                  },
                }}
                onClick={() => {
                  navigation("/Profile");
                  setAnchorEl(null);
                }}
              >
                Manage your profile
              </Button>
            </Grid> */}
            <Grid>
              <Button
                variant="outline"
                fullWidth
                sx={{
                  borderRadius: 10,
                  border: 1,
                  mt: "4px",
                  color: "primary.main",
                  fontWeight: "bold",
                  "@media (min-width: 1636px)": {
                    fontSize: "1rem",
                  },
                }}
                onClick={() => {
                  navigation("/LicenseInfo");
                  setAnchorEl(null);
                }}
              >
                Product Detail
              </Button>
            </Grid>
            <Grid>
              <Button
                id="LOGOUT"
                onClick={logout}
                variant="contained"
                fullWidth
                sx={{
                  borderRadius: 10,
                  border: 1,
                  backgroundColor: "primary.main",
                  color: "#FFF",
                  fontWeight: "bold",
                  mt: 3,
                  "@media (min-width: 1636px)": {
                    fontSize: "1rem",
                  },
                }}
              >
                Sign Out
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Popover>
    </div>
  );
};

export default Profile;
